"use client";

import type { CategoryPanelProps } from "../../../types/category-panel";
import { CategoryPanelMobile } from "../CategoryPanelMobile";
import { useIsMobile } from "@/shared/hooks/useIsMobile";
import { CategoryPanelDesktopDrawer } from "./CategoryPanelDesktopDrawer";

/**
 * CategoryPanel — variante "moderno".
 * Drawer pela esquerda com a lista de departamentos. Ao hover, um popover
 * (CategoryDetailCard) aparece grudado à direita do drawer, alinhado ao eixo Y
 * do item (ver CategoryPanelDesktopDrawer). No mobile (<=800px) delega ao
 * CategoryPanelMobile (navegação drill-down em dois níveis).
 */
export function CategoryPanelModern({ categories = [], onClose, title }: CategoryPanelProps) {
    const isMobile = useIsMobile(801);

    if (categories.length === 0) return null;

    if (isMobile) {
        return <CategoryPanelMobile categories={categories} onClose={onClose ?? (() => {})} />;
    }

    return <CategoryPanelDesktopDrawer categories={categories} onClose={onClose} title={title} />;
}
